<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="root-container">    
    <mat-progress-bar class="page-progress-bar" mode="indeterminate">
    </mat-progress-bar>
  </div> 
</ng-template>

<ng-template #content>
  <div class="root-container">
    <div class="header-container">
      <xpac-header></xpac-header>
    </div>
    <div class="content-container">
      <div class="notifier-container">
        <app-notifier></app-notifier>
      </div>
     <div id="content-container-content" class="content-container-content"> 
        <div [@routeAnimations]="prepareRoute(outlet)">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </div>
    <div class="footer-container">
      <xpac-footer *ngIf="showfooter"></xpac-footer>
    </div>
  </div>
</ng-template>